import { render, staticRenderFns } from "./LAppoint.vue?vue&type=template&id=6a885b16&scoped=true&"
import script from "./LAppoint.vue?vue&type=script&lang=js&"
export * from "./LAppoint.vue?vue&type=script&lang=js&"
import style0 from "./LAppoint.vue?vue&type=style&index=0&id=6a885b16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a885b16",
  null
  
)

export default component.exports